__webpack_require__.p = "/my-web-apps/react/react_trivial/";